// src/components/legal/DataDeletion.jsx
//
// /suppression-donnees - how to delete one's data, from the YummiTracker app or
// by e-mail: the page Google Play's « Sécurité des données » form asks for.
// What the app's « Effacer mes données » removes follows backend/routes/myData.ts
// (DELETE /api/v1/my-data); keep the two in step.
import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const TODO = (label) => <Box component="span" sx={{ bgcolor: '#FFF3CD', px: 0.5 }}>[À COMPLÉTER : {label}]</Box>;

export default function DataDeletion() {
  const h2 = { mt: 4, mb: 1, fontWeight: 800 };
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h3" component="h1" sx={{ fontWeight: 900, mb: 1 }}>Supprimer vos données</Typography>
      <Typography color="text.secondary">L'application YummiTracker et QRProof · {TODO('raison sociale')}</Typography>

      <Typography variant="h5" component="h2" sx={h2}>Depuis l'application YummiTracker</Typography>
      <Typography component="div">
        <ol>
          <li>Ouvrez YummiTracker et allez dans l'onglet <b>Paramètres</b>.</li>
          <li>Touchez <b>Mes données</b> pour voir ce que votre appareil a laissé.</li>
          <li>Touchez <b>Effacer mes données</b>, puis confirmez.</li>
        </ol>
        L'effacement est immédiat et définitif. Il supprime tout ce qui est lié à votre appareil :
        <ul>
          <li>vos notes et vos signalements ;</li>
          <li>votre pseudo et vos listes, avec leurs photos et leurs commentaires ;</li>
          <li>vos commentaires, vos photos, vos « j'aime », vos réactions, vos abonnements et vos votes aux défis ;</li>
          <li>vos jetons de notification et la zone approximative des notifications d'événements.</li>
        </ul>
        Nous ne gardons rien de ces données. Seuls les journaux techniques du serveur (adresse IP) restent, le temps de leur
        rotation automatique.
      </Typography>

      <Typography variant="h5" component="h2" sx={h2}>Sans l'application</Typography>
      <Typography>
        Si vous avez désinstallé l'app, vos notes restent liées à un identifiant aléatoire que nous ne pouvons pas relier à
        vous. Pour faire supprimer votre pseudo et ce que vous avez publié (listes, commentaires, photos), écrivez à{' '}
        {TODO('e-mail de contact')} en indiquant votre pseudo. Nous le faisons sous un mois.
      </Typography>

      <Typography variant="h5" component="h2" sx={h2}>Compte d'établissement QRProof</Typography>
      <Typography>
        Pour supprimer votre compte, vos établissements et les employés que vous avez ajoutés, écrivez à{' '}
        {TODO('e-mail de contact')} depuis l'adresse de votre compte. Nous le faisons sous un mois. Les factures sont
        conservées 10 ans par Paddle, comme la loi l'exige.
      </Typography>

      <Typography sx={{ mt: 4 }}>
        Pour le détail des données et de leur durée de conservation, voir la{' '}
        <Link href="/confidentialite">politique de confidentialité</Link>.
      </Typography>
    </Container>
  );
}
